import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import type { RegistryItem } from '../types/registry';

interface Props {
  item: RegistryItem;
  registryId: string;
  onClose: () => void;
}

export default function ThankYouModal({ item, registryId, onClose }: Props) {
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setSending(true);
      
      const { error } = await supabase
        .from('thank_you_notes')
        .insert({
          registry_id: registryId,
          item_id: item.id,
          to_user_id: item.claimed_by,
          message
        });

      if (error) throw error;
      onClose();
    } catch (error) {
      console.error('Error sending thank you note:', error);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/20 flex items-center justify-center p-4 z-50">
      <div className="card-pastel p-6 max-w-md w-full">
        <h3 className="text-lg font-semibold text-gray-800 mb-4 font-poppins">Send Thank You Note</h3>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1 font-poppins">
              Message
            </label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="w-full px-3 py-2 bg-white/60 border border-white/40 text-gray-800 rounded-md focus:ring-primary focus:border-primary font-poppins"
              rows={4}
              placeholder="Write your thank you message..."
              required
            />
          </div>
          <div className="flex justify-end space-x-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-600 hover:text-gray-800 font-poppins"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={sending}
              className="px-4 py-2 bg-primary text-white rounded-md hover:bg-primary-600 disabled:opacity-50 font-poppins"
            >
              {sending ? 'Sending...' : 'Send Note'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}